var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkeleton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 114.4,
    cy: 102.8,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,75.7H65.5l-5.2-5.2h13.9L29.3,25.6c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3l33.4,33.4c-1.8-0.7-3.9-0.3-5.4,1.2 c-2,2-2,5.3,0,7.3L85.3,110c2,2,4.5,2.9,7.1,2.9c2.6,0,5.1-1,7.1-2.9c2-2,2.9-4.5,2.9-7.1c0-2.6-1-5.1-2.9-7.1L79.4,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,68.5L35,70.5l43,43c4.8,4.8,11.2,7.5,18.1,7.5v-2.7c-6.1,0-11.8-2.4-16.1-6.7L36.9,68.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeleton);
export default __webpack_public_path__ + "static/media/skeleton.47a0d1f8be73161cc03a7727479fa038.svg";
export { ForwardRef as ReactComponent };